import { Sun, Moon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useTheme, isAdminRole } from "@/context/ThemeContext";
import { useUiMode } from "@/lib/uiMode";

export function useDarkMode() {
  const { user } = useAuth();
  const { theme } = useTheme();
  const [mode] = useUiMode();
  return mode ? mode === "dark" : isAdminRole(user?.role) && theme.admin_dark;
}

export function ModeToggle({ className = "" }) {
  const dark = useDarkMode();
  const [, setMode] = useUiMode();
  return (
    <button data-testid="ui-mode-toggle" onClick={() => setMode(dark ? "light" : "dark")} title={dark ? "Light mode" : "Dark mode"} className={`p-1.5 rounded-lg hover:bg-white/10 ${className}`}>
      {dark ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  );
}
